module.exports = __webpack_public_path__ + "static/media/PNG.5e905c1e.png";